//# sourceMappingURL=data_sources_styles.mjs.map
/// <reference types="./data_sources_styles.d.mts" />
import * as $colors from "../../../ds/ds/colors.mjs";
import * as $text from "../../../ds/ds/typography/text.mjs";
import * as $css from "../../../sketch/sketch/css.mjs";
import * as $length from "../../../sketch/sketch/css/length.mjs";
import { px } from "../../../sketch/sketch/css/length.mjs";
import * as $h from "../../../sketch_redraw/sketch/redraw/dom/html.mjs";
import { toList } from "../../gleam.mjs";

export function card(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.display("flex"),
      $css.flex_direction("column"),
      $css.border("1px solid " + $colors.light.grey_200),
      $css.border_radius(px(8)),
      $css.background($colors.light.blue_50),
      $css.overflow("hidden"),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}

export function header(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.display("flex"),
      $css.align_items("center"),
      $css.gap(px(4)),
      $css.padding(px(4)),
      $css.padding_left(px(8)),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}

export function header_title(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.flex("1"),
      $css.compose($text.sm($text.medium)),
      $css.color($colors.light.grey_800),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}

export function viewed_button(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.display("flex"),
      $css.align_items("center"),
      $css.compose($text.sm($text.medium)),
      $css.gap(px(8)),
      $css.border("1px solid " + $colors.light.grey_200),
      $css.color($colors.light.grey_600),
      $css.padding(px(4)),
      $css.padding_left(px(8)),
      $css.border_radius(px(8)),
      $css.background($colors.light.text_white),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}

export function body(attrs, children) {
  let _pipe = $css.class$(toList([$css.background($colors.light.text_white)]));
  return $h.div(_pipe, attrs, children);
}

export function source_body(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.padding(px(12)),
      $css.display("grid"),
      $css.gap(px(8)),
      $css.grid_template_columns("auto auto auto 1fr auto auto"),
      $css.align_items("center"),
      $css.grid_template_areas(
        toList([
          "version  status   language ........ .....  ..........",
          "question question question question owner  expiration",
          "answer   answer   answer   answer   answer answer",
          "tags     tags     tags     tags     tags   tags",
          "authors    authors    authors    authors    authors  authors",
        ]),
      ),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}

export function source_version(attrs, children) {
  let _pipe = $css.class$(toList([$css.grid_area("version")]));
  return $h.div(_pipe, attrs, children);
}

export function source_status(attrs, children) {
  let _pipe = $css.class$(toList([$css.grid_area("status")]));
  return $h.div(_pipe, attrs, children);
}

export function source_language(attrs, children) {
  let _pipe = $css.class$(
    toList([$css.grid_area("language"), $css.text_transform("capitalize")]),
  );
  return $h.div(_pipe, attrs, children);
}

export function source_question(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.grid_area("question"),
      $css.compose($text.md($text.regular)),
      $css.font_weight("bold"),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}

export function source_answer(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.grid_area("answer"),
      $css.border("1px solid " + $colors.light.grey_200),
      $css.padding(px(12)),
      $css.border_radius(px(8)),
      $css.compose($text.md($text.regular)),
      $css.color($colors.light.text_body),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}

export function source_tags(attrs, children) {
  let _pipe = $css.class$(toList([$css.grid_area("tags")]));
  return $h.div(_pipe, attrs, children);
}

export function source_authors(attrs, children) {
  let _pipe = $css.class$(toList([$css.grid_area("authors")]));
  return $h.div(_pipe, attrs, children);
}

export function source_author(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.display("flex"),
      $css.align_items("center"),
      $css.gap(px(8)),
      $css.compose($text.md($text.medium)),
      $css.background($colors.light.text_white),
      $css.border_radius(px(8)),
      $css.border("1px solid " + $colors.light.grey_200),
      $css.padding_("8px 16px"),
      $css.color($colors.light.grey_800),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}

export function source_owner(attrs, children) {
  let _pipe = $css.class$(toList([$css.grid_area("owner")]));
  return $h.div(_pipe, attrs, children);
}

export function source_expiration_date(attrs, children) {
  let _pipe = $css.class$(toList([$css.grid_area("expiration")]));
  return $h.div(_pipe, attrs, children);
}

export function source_expiration_date_input(attrs) {
  let _pipe = $css.class$(
    toList([
      $css.border("1px solid " + $colors.light.grey_400),
      $css.background($colors.light.text_white),
      $css.compose($text.sm($text.regular)),
      $css.color($colors.light.text_body),
      $css.display("block"),
      $css.font_family("inherit"),
      $css.padding_("9px 14px"),
      $css.border_radius(px(8)),
      $css.disabled(toList([$css.opacity(0.5)])),
    ]),
  );
  return $h.input(_pipe, attrs);
}

export function pagination(attrs, children) {
  let _pipe = $css.class$(
    toList([$css.display("flex"), $css.align_items("center"), $css.gap(px(2))]),
  );
  return $h.div(_pipe, attrs, children);
}

export function page_button(active, attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.width(px(40)),
      $css.height(px(40)),
      $css.border("1px solid " + $colors.light.grey_200),
      $css.color(
        (() => {
          if (active) {
            return $colors.light.text_white;
          } else {
            return $colors.light.text_body;
          }
        })(),
      ),
      $css.background(
        (() => {
          if (active) {
            return $colors.light.blue_800;
          } else {
            return $colors.light.text_white;
          }
        })(),
      ),
      $css.display("flex"),
      $css.align_items("center"),
      $css.justify_content("center"),
      $css.border_radius(px(4)),
      $css.text_decoration("none"),
      $css.first_child(
        toList([
          $css.border_top_left_radius(px(8)),
          $css.border_bottom_left_radius(px(8)),
        ]),
      ),
      $css.last_child(
        toList([
          $css.border_top_right_radius(px(8)),
          $css.border_bottom_right_radius(px(8)),
        ]),
      ),
    ]),
  );
  return $h.a(_pipe, attrs, children);
}
